module.exports = __webpack_public_path__ + "img/polygon.5480961c.svg";